import { render } from "./atcs-dashboard.html?vue&type=template&id=4e463734&scoped=true&ts=true&external"
import script from "./atcs-dashboard.ts?vue&type=script&lang=ts&external"
export * from "./atcs-dashboard.ts?vue&type=script&lang=ts&external"

import "./atcs-dashboard.scss?vue&type=style&index=0&id=4e463734&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e463734"]])

export default __exports__